import { useEffect } from "react";
import Avatar from "src/components/Avatar";
import Select from "src/components/field/fields/Select";
import { WrapperProps } from "src/components/field/utils/Wrapper";
import useUsers from "src/hooks/api/services/users/useUsers";

interface UserProps {
	isClearable?: boolean;
	wrapper?: WrapperProps;
	value?: number;
	onChange: (value?: number) => void;
}

const User = ({ isClearable, wrapper, value, onChange }: UserProps) => {
	const { users, status, actions } = useUsers();
	useEffect(() => {
		if (status === "idle" && !users.length) {
			actions.list();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Select
			{...{ wrapper, isClearable }}
			value={value ? value.toString() : undefined}
			onChange={(value) => onChange(value ? Number(value) : undefined)}
			options={users.map((user) => ({
				value: user.id.toString(),
				label: (
					<>
						<Avatar src={user.avatar} size="xsmall" />
						{user.full_name}
					</>
				),
			}))}
		/>
	);
};

export default User;
